import {
  StyledSelect
} from "./chunk-HN4IHMQT.mjs";
import {
  ErrorFilled_default
} from "./chunk-YCVZHSXA.mjs";
import {
  ChevronDown_default
} from "./chunk-4TXWYF6T.mjs";
import {
  __objRest,
  __spreadValues
} from "./chunk-SGYJX2RX.mjs";

// src/components/select/select-trigger.tsx
import React, { forwardRef } from "react";
var SelectTrigger = forwardRef(
  function SelectTrigger2(_a, ref) {
    var _b = _a, { clearable, children } = _b, rest = __objRest(_b, ["clearable", "children"]);
    return /* @__PURE__ */ React.createElement(StyledSelect.Control, __spreadValues({}, rest), /* @__PURE__ */ React.createElement(StyledSelect.Trigger, { ref }, children), /* @__PURE__ */ React.createElement(StyledSelect.IndicatorGroup, null, clearable && /* @__PURE__ */ React.createElement(StyledSelect.ClearTrigger, null, /* @__PURE__ */ React.createElement(ErrorFilled_default, null)), /* @__PURE__ */ React.createElement(StyledSelect.Indicator, null, /* @__PURE__ */ React.createElement(ChevronDown_default, null))));
  }
);

export {
  SelectTrigger
};
